import {Box} from "@mui/material";
import {useCallback} from "react";
import Window from "../components/Window/Window";
import ScopesResolveGrid from "../components/Scopes/ScopesResolveGrid";
import ScopesResolveFilter from "../components/Scopes/ScopesResolveFilter";
import usePaginationSearch from "../hooks/usePaginationSearch";
import useApiRequest from "../hooks/useApiRequest";

const ScopesPreview = () => {
  const {loading, makeRequest} = useApiRequest({});

  const fetcher = useCallback(
    async (query) => {
      const result = await makeRequest("GET", "/scopes/resolve", null, {params: query});
      if (!result?.success) return null;

      const rawData = result.data?.data || [];
      const data = rawData.map((item, index) => ({
        ...item,
        id: `${item.user_id}-${item.scope_id}-${item.role_id}-${item.tenant_id}-${index}`
      }));
      return {data: {data, pagination: result.data?.pagination}};
    },
    [makeRequest]
  );

  const {dataGridProps, applyFiltersFromObject, resetFilters} = usePaginationSearch({
    fetcher,
    initialItemsPerPage: 25
  });

  return (
    <Window title="Previsualizador de Scopes">
      <Box sx={{mt: 2}}>
        <ScopesResolveFilter onApplyFilters={applyFiltersFromObject} onClearFilters={resetFilters} />

        <Box mt={3}>
          <ScopesResolveGrid dataGridProps={dataGridProps} loading={loading} />
        </Box>
      </Box>
    </Window>
  );
};

export default ScopesPreview;
